import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

const COPY = {
  consultation: {
    title: "Your consultation request is in.",
    body: "Heather reviews requests personally and will reply within 1–2 business days with available dates and a final quote (visit base + any add-ons + travel).",
  },
  "group-class": {
    title: "Your group class request is in.",
    body: "Heather reviews group requests personally. You'll hear back within 1–2 business days with a quote, dates, and what we can build around your group.",
  },
  "virtual-consulting": {
    title: "Your virtual consulting request is in.",
    body: "Heather will reach out within 1–2 business days with scope, pricing, and a calendar link.",
  },
};

export default function RequestThanksPage() {
  const [params] = useSearchParams();
  const type = params.get("type") || "consultation";
  const c = COPY[type] || COPY.consultation;
  return (
    <>
      <NavBar />
      <main className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 sm:pt-20 pb-20 text-center">
        <CheckCircle2 className="mx-auto text-gg-green" size={48} />
        <h1 className="font-heading text-4xl sm:text-5xl text-[var(--gg-text)] leading-tight mt-5" data-testid="request-thanks-title">
          {c.title}
        </h1>
        <p className="mt-5 text-gg-muted leading-relaxed">{c.body}</p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="btn-pill btn-outline">Back To Home</Link>
          <Link to="/services" className="btn-pill btn-primary">
            Browse Other Services <ArrowRight size={14} />
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}
